export default __webpack_public_path__ + "static/doswiadczenie-32cd1ce97c08761e4e5a9230b7ec5935.png";